import React, { useEffect, useState } from "react";
import "../../src/styles/Home.css";
import {skills} from "../data/skills"
import profile from "../../src/images/1.jpg"
import { project } from "../data/projects";
import { education } from "../data/education";
import emailjs from "@emailjs/browser";
import { useRef } from "react";
import { TypeAnimation } from "react-type-animation";
import { certificates } from "../data/certificates";
import { FaGithub, FaLinkedin } from "react-icons/fa";


const Home = () => {
const [show,setShow] = useState(false)
const [selectedProject, setSelectedProject] = useState(null);

const open = (project) => {
  setSelectedProject(project);
  setShow(true);
};

const close = () => {
  setShow(false);
  setSelectedProject(null);
};

  useEffect(() => {
    // --------------------- PARTICLES JS ------------------------
    window.particlesJS("particles-js", {
      particles: {
        number: { value: 290, density: { enable: true, value_area: 800 } },
        color: { value: "#ffffff" },
        shape: {
          type: "triangle",
          stroke: { width: 0, color: "#000000" },
          polygon: { nb_sides: 10 },
        },
        opacity: { value: 0.5, random: false },
        size: { value: 3, random: true },
        line_linked: {
          enable: true,
          distance: 150,
          color: "#ffffff",
          opacity: 0.4,
          width: 1,
        },
        move: {
          enable: true,
          speed: 6,
          random: true,
          out_mode: "out",
        },
      },
      interactivity: {
        detect_on: "canvas",
        events: {
          onhover: { enable: true, mode: "repulse" },
          onclick: { enable: true, mode: "push" },
          resize: true,
        },
      },
      retina_detect: true,
    });



    // --------------------- SKILL SPHERE ------------------------
// --------------------- SKILL SPHERE ------------------------
const canvas = document.getElementById("skillCanvas");
const ctx = canvas.getContext("2d");

let width, height, radius;
function resizeCanvas() {
  const rect = canvas.getBoundingClientRect();
  width = canvas.width = rect.width;
  height = canvas.height = rect.height;
  radius = Math.min(width, height) / 2.2;
}
resizeCanvas();
window.addEventListener("resize", resizeCanvas);

const skills = [
  "Python", "Django", "React", "HTML", "CSS", "JavaScript",
  "MySQL", "MongoDB", "Git", "GitHub", "Bootstrap", "REST API"
];

const dots = [];
const total = skills.length;

for (let i = 0; i < total; i++) {
  const phi = Math.acos(-1 + (2 * i) / total);
  const theta = Math.sqrt(total * Math.PI) * phi;

  dots.push({
    text: skills[i],
    x: radius * Math.sin(phi) * Math.cos(theta),
    y: radius * Math.sin(phi) * Math.sin(theta),
    z: radius * Math.cos(phi)
  });
}

let angleX = 0.002;
let angleY = 0.002;

function rotateX(dot) {
  const y = dot.y * Math.cos(angleX) - dot.z * Math.sin(angleX);
  const z = dot.y * Math.sin(angleX) + dot.z * Math.cos(angleX);
  dot.y = y;
  dot.z = z;
}

function rotateY(dot) {
  const x = dot.z * Math.sin(angleY) + dot.x * Math.cos(angleY);
  const z = dot.z * Math.cos(angleY) - dot.x * Math.sin(angleY);
  dot.x = x;
  dot.z = z;
}

function animate() {
  ctx.clearRect(0, 0, width, height);

  ctx.textAlign = "center";       // 👈 ADD THIS
  ctx.textBaseline = "middle";    // 👈 ADD THIS

  const projected = [];

  dots.forEach((dot) => {
    rotateX(dot);
    rotateY(dot);

    const scale = 300 / (300 + dot.z);
    const x = dot.x * scale + width / 2;
    const y = dot.y * scale + height / 2;

    projected.push({ x, y, z: dot.z });

    ctx.font = `${18 * scale + 12}px Poller One`;
    ctx.fillStyle = "#fff";
    ctx.fillText(dot.text, x, y);
  });

  // ---------------- LINE DRAWING WHEN CLOSE ----------------
// ---------------- LINE DRAWING WHEN CLOSE ----------------
for (let i = 0; i < projected.length; i++) {
  for (let j = i + 1; j < projected.length; j++) {
    const dx = projected[i].x - projected[j].x;
    const dy = projected[i].y - projected[j].y;
    const dist = Math.sqrt(dx * dx + dy * dy);

    const maxDist = 170; // <-- increased distance for more lines

    if (dist < maxDist) {
      let opacity = 1 - dist / maxDist; // fades based on new distance
      ctx.strokeStyle = `rgba(255,255,255,${opacity})`;
      ctx.lineWidth = 1;

      ctx.beginPath();
      ctx.moveTo(projected[i].x, projected[i].y);
      ctx.lineTo(projected[j].x, projected[j].y);
      ctx.stroke();
    }
  }
}


  requestAnimationFrame(animate);
}

animate();


  }, []);

  const form = useRef();

const sendEmail = (e) => {
  e.preventDefault();

  emailjs.sendForm(
    "service_pmtvwvd",
    "template_2nhur7j",
    form.current,
    "he4YdHW0jmohcBVuT"
  )
  .then(() => {
      alert("Message sent successfully ✅");
      form.current.reset();
  })
  .catch(() => {
      alert("Failed to send ❌");
  });
};

  return (
    <div>
      {/* HERO SECTION */}
      <section id="particles-js">
        <div className="hero-content">
          <div className="hero-text">
            <h1>Hi, I am Rohini Sureshbabu</h1>
            {/* <h3>Python Full-Stack Developer Intern</h3> */}
            {/* <h1 className="hero-name">Hi, I'm Rohini 👋</h1> */}

            <h2 className="hero-role">
              I am a{" "}
              <span className="highlight">
                <TypeAnimation
                  sequence={[
                    "Python Fullstack Developer",
                    2000,
                    "Python Developer",
                    2000,
                    "React Developer",
                    2000,
                    "Frontend Developer",
                    2000,
                    "Backend Developer",
                    2000,
                  ]}
                  speed={60}
                  repeat={Infinity}
                  cursor={true}
                />
              </span>
            </h2>
          </div>

          <img src={profile} alt="Rohini" className="hero-img" />
        </div>
      </section>


      {/* ABOUT */}
      <section id="about">
        <div id="div2">
          <h2>About Me</h2>
          <p>
            A motivated Computer Science and Engineering Graduate with a strong
            foundation in theoretical principles and problem-solving. Passionate
            about backend, frontend, and full-stack development with real-world projects.
          </p>
        </div>
      </section>

      {/* EDUCATION */}
      <section id="education">
        <h2>Education</h2>

        <div className="education-section">
          {education.map((item, index) => (
            <div className="edu-card" key={index}>
              <h3>{item.degree}</h3>
              <h4>{item.school}</h4>
              <h4>{item.year}</h4>
            </div>
          ))}
        </div>

      </section>


      {/* SKILLS SECTION */}
      <section id="skills">
        <h1 className="skills-title">Skills</h1>
        <div className="skill-section">
          <canvas id="skillCanvas"></canvas>
        </div>
        {/* <div> */}
          <ul className="skills">
            {skills.map((skill, index) => (
              <li key={index}>{skill}</li>
            ))}
          </ul>

        {/* </div> */}
      </section>
      <section id="projects" className="project">
        <h1>Projects</h1>

        <div className="gallery">
          {project.map((project, i) => (
            <div className="imgWrapper" key={i}>
              <img src={project.image} alt="" />
              <span className="desc">{project.title}</span>
              <div className="btnGroup">
                <button onClick={() => open(project)}>View</button>
              </div>
            </div>
          ))}
        </div>

        
      </section>
      {show && selectedProject && (
  <div className="popupOverlay" onClick={close}>
    <div className="popupBox" onClick={(e) => e.stopPropagation()}>

      {/* Image */}
      <img 
        src={selectedProject.image} 
        alt="" 
        className="popupImage"
      />

      {/* Title */}
      <h2>{selectedProject.title}</h2>

      {/* Description */}
      <p className="popupDesc">{selectedProject.desc}</p>

      {/* Tech Stack */}
      {selectedProject.tech && (
        <div className="techStack">
          {selectedProject.tech.map((t, i) => (
            <span key={i}>{t}</span>
          ))}
        </div>
      )}

      {/* Buttons */}
      <div className="popupButtons">
        {selectedProject.live && (
          <a href={selectedProject.live} target="_blank" rel="noreferrer">
            <button className="liveBtn">Live Demo</button>
          </a>
        )}

        {selectedProject.code && (
          <a href={selectedProject.code} target="_blank" rel="noreferrer">
            <button className="codeBtn">View Code</button>
          </a>
        )}
      </div>

      <button className="closeBtn" onClick={close}>✕</button>
    </div>
  </div>
)}
{/* CERTIFICATES */}
<section id="section-certificates">
  <h2>Certificates</h2>

  <div className="certificate-section">
    {certificates.map((item, index) => (
      <div className="certificate-card" key={index}>
        <h3>{item.title}</h3>
        <h4>{item.issuer}</h4>
        <p>{item.year}</p>
      </div>
    ))}
  </div>
</section>



 
   <section id="contact" className="connect">
  <h1 className="contact-title">Connect with Me</h1>

  <form ref={form} onSubmit={sendEmail} className="contact">

    <div className="inputBox">
      <input type="text" name="name" required />
      <label>Name</label>
    </div>

    <div className="inputBox">
      <input type="email" name="email" required />
      <label>Email</label>
    </div>

    <div className="inputBox">
      <textarea name="message" required></textarea>
      <label>Message</label>
    </div>

    <button type="submit" className="myBtn">
      Send Message
    </button>
  </form>

  {/* Social Links */}
  <div className="social-links">
    <a 
      href="https://github.com/Rohini6697" 
      target="_blank" 
      rel="noopener noreferrer"
      className="social-icon"
    >
      <FaGithub />
    </a>

    <a 
      href="https://www.linkedin.com/in/rohini-sureshbabu-479530317/" 
      target="_blank" 
      rel="noopener noreferrer"
      className="social-icon"
    >
      <FaLinkedin />
    </a>
  </div>
</section>
    

    </div>
  );
};

export default Home;
